import * as React from 'react';

import CookieLayer from 'components/cookieLayer/CookieLayer';
import FooterLink from 'components/footer/FooterLink';

import * as styles from './footer.scss';

import { translate } from 'utils/translateUtil';
import {ROUTES} from 'constants/routes';

import SVGLogoFooterMobile from 'components/svg/LogoFooterMobile';
import SVGContact from 'components/svg/Contact';
import SVGBranchFinder from 'components/svg/BranchFinder';
import SVGImprint from 'components/svg/Imprint';
import SVGPrivacyPolicy from 'components/svg/PrivacyPolicy';
import SVGSafety from 'components/svg/Safety';

type Props = {
    cookiesAccepted:boolean;
};
const Footer: React.SFC<Props> = props => {

    const linksLeft = [
        {
            'link': ROUTES.FOOTER_CONTACT,
            'target': '_blank',
            'text': translate('footer.contact'),
            'icon': <SVGContact/>
        },
        {
            'link': ROUTES.FOOTER_STORE_FINDER,
            'target': '_blank',
            'text': translate('footer.store-finder'),
            'icon': <SVGBranchFinder/>
        }
    ];

    const linksRight = [
        {
            'link': ROUTES.FOOTER_SAFETY_INFO,
            'target': '_blank',
            'text': translate('footer.safety-info'),
            'icon': <SVGSafety/>
        },
        {
            'link': ROUTES.FOOTER_DATA_PROTECTION,
            'target': '_blank',
            'text': translate('footer.data-protection'),
            'icon': <SVGPrivacyPolicy/>
        },
        {
            'link': ROUTES.FOOTER_IMPRINT,
            'target': '_blank',
            'text': translate('footer.imprint'),
            'icon': <SVGImprint/>
        }
    ];


    return (
        <footer className={styles.footer}>

            {!props.cookiesAccepted &&
                <CookieLayer />
            }
            <div className={styles.wrapper}>
                    <div className={styles.listWp}>
                        {
                            linksLeft.map((item:any, index:number) => {
                                return <FooterLink item={item} key={index}/>
                            })
                        }
                    </div>
                    <div className={styles.listWp}>
                        {
                            linksRight.map((item:any, index:number) => {
                                return <FooterLink item={item} key={index}/>
                            })
                        }
                    </div>
                    <span className={styles.logoWp}>
                        <SVGLogoFooterMobile/>
                    </span>
            </div>
        </footer>
    )
}

export default Footer;